import React, { useState } from 'react';
import { withBus } from 'react-bus';
import Input from '@mui/material/Input';
import { withQuerySubtab } from 'src/utils/hoc';
import { EventBus } from 'src/types/utils';

/**
 * A widget that allows the displayed reviews to be filtered by some keyword.  It emits the `filterReviewKeyword` event
 * whenever the keyword is changed.
 */
const FilterKeywords = ({ eventBus, querySubtab }: { eventBus: EventBus; querySubtab: string }) => {
  const [searchingValue, setSearchingValue] = useState('');

  if (querySubtab !== 'reviewTrends') {
    return null;
  }

  return (
    <div style={{ width: '100%', marginBottom: '20px' }}>
      <Input
        autoComplete="off"
        className="review-metrics__search-bar"
        placeholder="Filter by keyword"
        type="text"
        value={searchingValue}
        name="review"
        id="review"
        style={{ width: '100%' }}
        onChange={(evt) => setSearchingValue(evt.target.value)}
        onKeyPress={(evt) => {
          if (evt.key === 'Enter') {
            eventBus.emit('filterReviewKeyword', (evt.target as any).value);
          }
        }}
      />
    </div>
  );
};

const EnhancedFilterKeywords = withBus('eventBus')(withQuerySubtab(FilterKeywords));

export default EnhancedFilterKeywords;
